<template>
  <div class="phone-field-with-constraint">
    <div class="phone-field-with-constraint__label label-title">
      {{ $t('dashboard.formulation.phoneNumber') }}
    </div>

    <vue-tel-input
      v-model="localPhoneNumber"
      class="phone-field-with-constraint__phone-field"
      :auto-format="true"
      :default-country="isoCode"
      :valid-characters-only="true"
      mode="national"
      :enable-area-codes="true"
      @country-changed="updateIsoCode"
      @input="updatePhoneNumber"
    />

    <dashboard-constraint
      v-if="!isAlmaTerritory"
      :value="constraint"
      :constraint-text="constraintText"
      :hint-text="constraintHint"
      :disabled="isConstraintDisabled"
      @input="updateConstraint"
    />
  </div>
</template>

<script>
import PhoneEditField from '@/modules/dashboard/components/profile/PhoneEditField';
import DashboardConstraint from '@/modules/dashboard/components/dashboard/common/DashboardConstraint';
import { ALMA_TERRITORIES } from '@/modules/dashboard/constants/alma-countries';
import { VueTelInput } from 'vue-tel-input';

import { mapGetters } from 'vuex';
import rootTypes from '@/store/types';

export default {
  name: 'PhoneFieldWithConstraint',
  components: { DashboardConstraint, PhoneEditField, VueTelInput },
  props: {
    isoCode: {
      type: String,
      required: true
    },
    phoneNumber: {
      type: String,
      required: true
    },
    constraint: {
      type: Boolean,
      default: false
    },
    constraintText: {
      type: String,
      default: ''
    },
    constraintHint: {
      type: String,
      default: ''
    },
    isConstraintDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      doctorCountry: rootTypes.getters.GET_USER_COUNTRY
    }),
    isAlmaTerritory() {
      return ALMA_TERRITORIES.includes(this.doctorCountry);
    },
    localPhoneNumber: {
      get() {
        return this.phoneNumber;
      },
      set(value) {
        this.updatePhoneNumber(value);
      }
    }
  },
  methods: {
    updateIsoCode(isoCode) {
      this.$emit('update-iso-code', isoCode.iso2);
    },
    updatePhoneNumber(phoneNumber) {
      this.$emit('update-phone-number', phoneNumber);
    },
    updateConstraint(constraint) {
      this.$emit('update-constraint', constraint);
    }
  }
};
</script>

<style src="vue-tel-input/dist/vue-tel-input.css"></style>

<style lang="scss" scoped>
@import '../../../../../assets/scss/common/text';
@import '../../../../../assets/scss/common/vue-tel-input';

::v-deep .vti__input {
  border-radius: 0 5px 5px 0;
}
</style>
